<!-- 
Contents of the HISTORY tab of the invoice page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      :nav-url="getNavUrl('history')"
      arrived-from-listing
      user-guide-topic="levy-collection-invoices"
      module="invoices"
    >
      <template v-if="arrivedFromLevyCollection" v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :invoice-id="invoiceId" :levy-collection-id="invoice.levyCollectionId" :provider-id="invoice.providerId" path="history">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters"
        title="Search invoice history" 
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing
        ref="history"
        :endpoint="`/api/invoices/${invoiceId}/history`" 
        :export-endpoint="`/api/exports/invoices/${invoiceId}/history`"
        :export-validate-endpoint="`/api/exports/validate/invoices/${invoiceId}/history`"
        embedded 
      />
    </tabs>
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import Tabs from "./Tabs.vue";
import invoiceMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "InvoiceHistory",
  components: { LevyCollectionNavigator, SystemLogListing, Tabs },
  mixins: [invoiceMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("InvoiceAction", true);
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
